"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _IdeaView = _interopRequireDefault(require("./IdeaView"));

var _MobileFilterList = _interopRequireDefault(require("./MobileFilterList"));

var _axios = _interopRequireDefault(require("axios"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _index = _interopRequireDefault(require("@insided/shared/uikit/dropdown/index"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _classnames = _interopRequireDefault(require("classnames"));

var _qs = _interopRequireDefault(require("qs"));

var _shared = require("@insided/destination/modules/Navigation/shared");

var _Skeleton = require("@insided/shared/uikit/Skeleton");

var _formatCount = require("@insided/shared/utils/formatCount");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'ideation-list';
exports.cssAnchorName = cssAnchorName;

var IdeasOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeasOverview, _Component);

  var _super = _createSuper(IdeasOverview);

  function IdeasOverview() {
    var _this$props$ideas$top, _this$props$ideas;

    var _this;

    (0, _classCallCheck2.default)(this, IdeasOverview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isPageNumberIncreased", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showBackButton", parseInt(_this.props.currentPage) !== 1);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sortOptions", {
      lastpost: 'sort.thread.lastpost.desc',
      dateline: 'sort.thread.dateline.desc',
      replycount: 'sort.thread.replycount.desc',
      votes: 'sort.thread.votes.desc'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      ideas: (_this$props$ideas$top = (_this$props$ideas = _this.props.ideas) === null || _this$props$ideas === void 0 ? void 0 : _this$props$ideas.topics) !== null && _this$props$ideas$top !== void 0 ? _this$props$ideas$top : [],
      // ideas can be null
      currentPage: parseInt(_this.props.currentPage),
      totalPageCount: _this.props.totalPageCount,
      totalTopicCount: _this.props.totalTopicCount,
      selectedSortOption: _this.props.selectedSortOption || 'lastActivityAt'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSortOption", function (sortKey) {
      _this.setState({
        selectedSortOption: sortKey
      }, function () {
        return (0, _shared.setQueryParams)({
          page: _this.state.currentPage,
          sort: "".concat(_this.state.selectedSortOption)
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPagination", function (newPage) {
      if (newPage > _this.state.currentPage) {
        _this.isPageNumberIncreased = true;
      }

      _this.setState({
        currentPage: newPage
      }, function () {
        return (0, _shared.setQueryParams)({
          page: _this.state.currentPage
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNewTopicsList", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var params, res;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = (0, _shared.getParamsForUnified)(_this.state.selectedSortOption);

              _this.setState({
                isLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return _axios.default.get('/ideas/topics', {
                params: params
              });

            case 5:
              res = _context.sent;

              if (res.data) {
                // Hide show back button if filters are changing except pagination
                if (!_this.isPageNumberIncreased) {
                  _this.showBackButton = false;
                }

                _this.setState(function (prevState) {
                  return {
                    ideas: _this.isPageNumberIncreased ? prevState.ideas.concat(res.data.topics) : res.data.topics,
                    currentPage: _this.isPageNumberIncreased ? prevState.currentPage : 1,
                    totalPageCount: res.data.totalPageCount,
                    totalTopicCount: res.data.totalTopicCount,
                    isLoading: false
                  };
                });

                _this.isPageNumberIncreased = false;
              }

              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);

              _logger.logger.error(_context.t0, {
                component: 'IdeasOverview',
                action: 'getNewTopicsList'
              });

              _this.isPageNumberIncreased = false;

              _this.setState({
                isLoading: false
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(IdeasOverview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window === 'undefined') {
        // SSR guard
        return;
      }

      IdeasOverview.overrideHistoryPushState();

      window.history.onpushstate = function () {
        // pushstate is async event, without setTimeout it is getting previous state
        window.setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.getNewTopicsList();

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })), 0);
      };

      window.addEventListener('popstate', IdeasOverview.handleBackNavigation);
    }
  }, {
    key: "render",
    value: function render() {
      var _qs$parse$filters,
          _ref4,
          _,
          _ref5,
          _this3 = this;

      var _ref3 = this.props || {},
          isGuest = _ref3.isGuest,
          currentUserId = _ref3.currentUserId,
          authors = _ref3.authors,
          categories = _ref3.categories,
          productAreas = _ref3.productAreas,
          ideationStatuses = _ref3.ideationStatuses;

      var _this$state = this.state,
          ideas = _this$state.ideas,
          currentPage = _this$state.currentPage,
          isLoading = _this$state.isLoading,
          totalPageCount = _this$state.totalPageCount,
          totalTopicCount = _this$state.totalTopicCount,
          selectedSortOption = _this$state.selectedSortOption;
      var searchQuery = typeof window !== 'undefined' ? window.location.search : '';
      var filters = (_qs$parse$filters = _qs.default.parse(searchQuery, {
        ignoreQueryPrefix: true
      }).filters) !== null && _qs$parse$filters !== void 0 ? _qs$parse$filters : {};
      var selectedProductAreaIds = (_ref4 = filters.productArea) !== null && _ref4 !== void 0 ? _ref4 : [];
      var selectedIdeationStatus = (_ = ((_ref5 = filters.ideationStatus) !== null && _ref5 !== void 0 ? _ref5 : [])[0]) !== null && _ !== void 0 ? _ : null;
      var hasMobileFilters = !!(productAreas !== null && productAreas !== void 0 && productAreas.length) || !!(ideationStatuses !== null && ideationStatuses !== void 0 && ideationStatuses.length);
      return (0, _preact.h)("div", {
        className: "ideation-overview-list widget-wrapper"
      }, hasMobileFilters ? (0, _preact.h)("div", {
        className: "ideation-mobile-filters is-hidden-L"
      }, ideationStatuses !== null && ideationStatuses !== void 0 && ideationStatuses.length ? (0, _preact.h)("div", {
        className: "ideation-mobile-filters__section"
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "filter.by.idea.status"
      })), (0, _preact.h)("ul", {
        className: "ideation-mobile-filters__list"
      }, (0, _preact.h)("li", null, (0, _preact.h)("button", {
        type: "button",
        className: (0, _classnames.default)('ideation-mobile-filters__item', {
          selected: !selectedIdeationStatus
        }),
        onClick: function onClick() {
          return IdeasOverview.onIdeaStatusSelect(null);
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "all.statuses"
      }))), ideationStatuses.map(function (status) {
        return (0, _preact.h)("li", {
          key: status.name
        }, (0, _preact.h)("button", {
          type: "button",
          className: (0, _classnames.default)('ideation-mobile-filters__item', {
            selected: selectedIdeationStatus === status.name
          }),
          onClick: function onClick() {
            return IdeasOverview.onIdeaStatusSelect(status.name);
          }
        }, status.name));
      }))) : null, productAreas !== null && productAreas !== void 0 && productAreas.length ? (0, _preact.h)("div", {
        className: "ideation-mobile-filters__section"
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "filter.by.product"
      })), (0, _preact.h)("ul", {
        className: "ideation-mobile-filters__list"
      }, (0, _preact.h)("li", null, (0, _preact.h)("button", {
        type: "button",
        className: (0, _classnames.default)('ideation-mobile-filters__item', {
          selected: selectedProductAreaIds.length === 0
        }),
        onClick: function onClick() {
          return IdeasOverview.onProductAreaSelect(null);
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "all.products"
      }))), productAreas.flatMap(function (pa) {
        return pa.isSection ? pa.children : [pa];
      }).map(function (pa) {
        return (0, _preact.h)("li", {
          key: pa.id
        }, (0, _preact.h)("button", {
          type: "button",
          className: (0, _classnames.default)('ideation-mobile-filters__item', {
            selected: selectedProductAreaIds.includes(String(pa.id))
          }),
          onClick: function onClick() {
            return IdeasOverview.onProductAreaSelect(pa.id);
          }
        }, pa.name));
      }))) : null) : null, (0, _preact.h)(_MobileFilterList.default, {
        categories: categories
      }), (0, _preact.h)("header", {
        className: "overview-list-header"
      }, (0, _preact.h)("h3", {
        className: "widget__heading"
      }, (0, _preact.h)(_phrase.default, {
        p: "{n} idea| {n} ideas",
        count: {
          n: (0, _formatCount.formatCount)(totalTopicCount)
        }
      }, function (phrase) {
        return phrase || (0, _preact.h)(_Skeleton.TextSkeleton, null);
      })), (0, _preact.h)("nav", null, (0, _preact.h)(_index.default, {
        popupName: "ideation-list-sort",
        class: "dropdown dropdown--sort-options",
        closeOnDropdownClick: true,
        triggerClass: "dropdown--sort-options-trigger",
        trigger: (0, _preact.h)("span", {
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          className: "sort-option-trigger"
        }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          p: this.sortOptions[selectedSortOption]
        }, function (phrase) {
          return phrase || (0, _preact.h)(_Skeleton.TextSkeleton, null);
        })), (0, _preact.h)(_ChevronDown.default, null))
      }, Object.keys(this.sortOptions).filter(function (option) {
        return option !== selectedSortOption;
      }).map(function (option) {
        return (0, _preact.h)("div", {
          role: "button",
          tabIndex: 0,
          key: option,
          className: "dropdown--sort-option",
          onClick: function onClick() {
            return _this3.setSortOption(option);
          }
        }, (0, _preact.h)(_phrase.default, {
          p: _this3.sortOptions[option]
        }));
      })))), ideas.length ? (0, _preact.h)("div", {
        className: "list-widget-wrapper"
      }, this.showBackButton ? (0, _preact.h)("div", {
        className: "load-more-container load-more-topics"
      }, (0, _preact.h)("button", {
        className: "btn--cta btn--full-width btn--load-more ".concat(isLoading ? 'is-loading disabled' : ''),
        onClick: function onClick() {
          return _this3.setPagination(1);
        },
        type: "button"
      }, "Back to top of the list", (0, _preact.h)("span", {
        className: "loader"
      }))) : null, ideas.map(function (idea) {
        return (0, _preact.h)(_IdeaView.default, (0, _extends2.default)({
          key: idea.id
        }, idea, {
          authorData: authors,
          isGuest: isGuest,
          currentUserId: currentUserId,
          categoryName: idea === null || idea === void 0 ? void 0 : idea.categoryName
        }));
      }), currentPage < totalPageCount ? (0, _preact.h)("div", {
        className: "load-more-container load-more-topics"
      }, (0, _preact.h)("button", {
        className: "btn--cta btn--full-width btn--load-more ".concat(isLoading ? 'is-loading disabled' : ''),
        onClick: function onClick() {
          return _this3.setPagination(currentPage + 1);
        },
        type: "button"
      }, (0, _preact.h)(_phrase.default, {
        p: "Show more"
      }), (0, _preact.h)("span", {
        className: "loader"
      }), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/ideas?page=".concat(currentPage + 1))
      }))) : null) : (0, _preact.h)("div", {
        className: (0, _classnames.default)('box', 'thread-list-block', 'thread-list-block-empty-status', 'thread-list-block--meta', 'forum-list-view-spacing', 'forum-list-view-spacing--v-s')
      }, (0, _preact.h)("p", {
        className: "p--full-width"
      }, "No result found"), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new?type=idea"),
        onClick: IdeasOverview.handleCreteIdeaClick,
        onKeyDown: function onKeyDown(e) {
          return e.key === 'Enter' && IdeasOverview.handleCreteIdeaClick(e);
        },
        tabIndex: 0,
        className: (0, _classnames.default)('btn--cta', 'btn--new-topic', 'qa-topic-new-button')
      }, (0, _preact.h)(_phrase.default, {
        p: "create.an.idea",
        m: "Forum"
      }))));
    }
  }], [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', IdeasOverview.handleBackNavigation);
    }
  }]);
  return IdeasOverview;
}(_preact.Component);

(0, _defineProperty2.default)(IdeasOverview, "handleCreteIdeaClick", function (event) {
  event.preventDefault();
  var urlParams = new URLSearchParams(window.location.search);
  var productAreaId = urlParams.get('filters[productArea][0]');
  window.location.href = (0, _absoluteUrlRuntime.resolveUrl)(productAreaId ? "/topic/new?type=idea&productAreaId=".concat(productAreaId) : '/topic/new?type=idea');
});
(0, _defineProperty2.default)(IdeasOverview, "onProductAreaSelect", function (productAreaId) {
  (0, _shared.updateQueryFilters)({
    productArea: productAreaId ? [productAreaId] : null
  });
});
(0, _defineProperty2.default)(IdeasOverview, "onIdeaStatusSelect", function (status) {
  (0, _shared.updateQueryFilters)({
    ideationStatus: status ? [status] : null
  });
});
(0, _defineProperty2.default)(IdeasOverview, "handleBackNavigation", function () {
  return window.location.reload();
});
(0, _defineProperty2.default)(IdeasOverview, "overrideHistoryPushState", function () {
  var pushState = window.history.pushState.bind(window.history);

  window.history.pushState = function (state) {
    if (typeof window.history.onpushstate === 'function') {
      window.history.onpushstate({
        state: state
      });
    }

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return pushState.apply(void 0, [state].concat(args));
  };
});
var _default = IdeasOverview;
exports.default = _default;